// redux/types.ts

export const SET_IS_PERSONAL = "SET_IS_PERSONAL";
export const SET_IS_DARK = "SET_IS_DARK";
export const SET_USER = "SET_USER";
export const SET_PROFILE_LOADED = "SET_PROFILE_LOADED";
export const SET_HAS_MERCHANT = "SET_HAS_MERCHANT";
export const SET_WEBSOCKET_LOADED = "SET_WEBSOCKET_LOADED";
export const SET_PROFILE_MERCHANT_DATA = "SET_PROFILE_MERCHANT_DATA";

// New action types for error handling
export const SET_ERROR = "SET_ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";

// New action type for resetting the state
export const RESET_STATE = "RESET_STATE";
export const ADD_HISTORY = "ADD_HISTORY";

export const ADD_MERCHANT = "ADD_MERCHANT";

export const SET_SELECTED_TRADE_ID = "SET_SELECTED_TRADE_ID";
export const SET_RAMP_DETAILS_BUY = "SET_RAMP_DETAILS_BUY";
export const SET_RAMP_DETAILS_SELL = "SET_RAMP_DETAILS_SELL";
export const SET_RELOAD_TRADES = "SET_RELOAD_TRADES";

export const SET_IS_CREATE_MERCHANT = "SET_IS_CREATE_MERCHANT";

// Token list caching
export const SET_TOKEN_LIST = "SET_TOKEN_LIST";
export const SET_TOKEN_LIST_LOADING = "SET_TOKEN_LIST_LOADING";
export const CLEAR_TOKEN_LIST = "CLEAR_TOKEN_LIST";
export const UPDATE_TOKEN_BALANCE = "UPDATE_TOKEN_BALANCE";
